var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoInspectionEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    fill: "#FF6019",
    fillOpacity: 0.16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_259_1758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.2158 32.6345L35.8797 32.6345C34.8696 32.6345 33.9008 33.0217 33.1865 33.7108C32.4722 34.3999 32.0709 35.3345 32.0709 36.3091V58.3563C32.0709 59.3309 32.4722 60.2655 33.1865 60.9546C33.9008 61.6437 34.8696 62.0308 35.8797 62.0308H54.9239C55.934 62.0308 56.9028 61.6437 57.6171 60.9546C58.3314 60.2655 58.7327 59.3309 58.7327 58.3563V36.3091C58.7327 35.3345 58.3314 34.3999 57.6171 33.7108C56.9028 33.0217 55.934 32.6345 54.9239 32.6345L53.247 32.6345",
    stroke: "#FF6019",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4782 27.1653H41.9837C39.089 27.1653 37.54 29.0017 37.54 31.2671C37.54 33.5325 39.089 35.3689 41.9837 35.3689H48.4782C51.3728 35.3689 53.2637 33.5325 53.2637 31.2671C53.2637 29.0017 51.3728 27.1653 48.4782 27.1653Z",
    stroke: "#FF6019",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5714 41.7856H38.5942",
    stroke: "#FF6019",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5714 48.2141H38.5942",
    stroke: "#FF6019",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5714 54.6428H38.5942",
    stroke: "#FF6019",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4153 41.7856H52.2546",
    stroke: "#FF6019",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3928 48.2141H52.2321",
    stroke: "#FF6019",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3928 54.6428H46.6071",
    stroke: "#FF6019",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_259_1758"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.8036,
    height: 45.8036,
    fill: "white",
    transform: "translate(22.5 21.6963)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoInspectionEmpty);
export default __webpack_public_path__ + "static/media/roInspectionEmpty.7f8ae2d2.svg";
export { ForwardRef as ReactComponent };